export * from './checkbox.component'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/category-checkbox/index.ts